<div bsModal #modal="bs-modal" class="modal fade email-template-form" tabindex="-1" role="dialog" aria-hidden="false">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">{{ 'Edit template' | translate }}</h4>
            </div>
            <div class="modal-body">
                <form [formGroup]="form" novalidate (ngSubmit)="submit(form.value, form.valid)">
                    <input type="hidden" formControlName="id">
                    <input type="hidden" formControlName="clinic_id">
                    <div *ngIf="successMessage" class="row form-group" role="alert">
                        <div class="col-sm-12">
                            <div class="alert alert-info">
                                {{ successMessage | translate }}
                            </div>
                        </div>
                    </div>
                    <div *ngIf="errorMessage.length > 0" class="row form-group" role="alert">
                        <div class="col-sm-10">
                            <div class="alert alert-danger">
                                <div *ngFor="let error of errorMessage">
                                    <i class="fas fa-exclamation-circle" aria-hidden="true"></i>
                                    {{ error | translate}}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="form-group col-xs-12">
                            <label for="title">{{ 'Template type' | translate }}</label>
                            <br>
                            <strong>{{ emailTemplate['type_name'] | translate }}</strong>
                            <span *ngIf="emailTemplate && emailTemplate['language_flag']">
                                <img [src]="emailTemplate['language_flag']" [alt]="emailTemplate['language_code']">
                            </span>
                            <label class="revert-button" *ngIf="isClinicTemplate">
                                <a (click)="resetDefaultTemplate()"
                                   title="{{ 'Revert to default' | translate }}">
                                    <i class="fas fa-undo"></i> {{ 'Revert to default' | translate }}
                                </a>
                            </label>
                        </div>
                    </div>
                    <div class="row" [hidden]="notShowTitle">
                        <div class="form-group col-xs-12">
                            <label for="title">{{ 'Template name' | translate }} *</label>
                            <input type="text" class="form-control" id="title" formControlName="title">
                            <small class="form-text text-danger" [hidden]="form.controls.title.valid ||
                                                                           (form.controls.title.pristine &&
                                                                           !formSubmitted)">
                                {{ 'Template name is required.' | translate }}
                            </small>
                        </div>
                    </div>
                    <div class="row" [hidden]="notShowTitle">
                        <div class="form-group col-xs-12">
                            <label for="email_subject">{{ 'Email Subject' | translate }} *</label>
                            <input type="text" class="form-control" id="email_subject" formControlName="email_subject">
                            <small class="form-text text-danger" [hidden]="form.controls.email_subject.valid ||
                                                                           (form.controls.email_subject.pristine &&
                                                                           !formSubmitted)">
                                {{ 'Email subject is required.' | translate }}
                            </small>
                        </div>
                    </div>
                    <div class="row" [hidden]="notShowTitle">
                        <div class="form-group col-xs-12">
                            <label for="email_header">{{ 'Email header' | translate }} *</label>
                            <input type="text" class="form-control" id="email_header" formControlName="email_header">
                            <small class="form-text text-danger" [hidden]="form.controls.email_header.valid ||
                                                                           (form.controls.email_header.pristine &&
                                                                           !formSubmitted)">
                                {{ 'Email header is required.' | translate }}
                            </small>
                        </div>
                    </div>
                    <div class="row">
                        <div class="form-group col-xs-12">
                            <label for="title">{{ 'Template Content' | translate }} *</label>
                            <app-tinymce #tinymce formControlName="content" id="content" [options]="{convert_urls: false}"></app-tinymce>
                            <small class="form-text text-danger" [hidden]="form.controls.content.valid ||
                                                                           (form.controls.content.pristine &&
                                                                           !formSubmitted)">
                                {{ 'Content or link is required.' | translate }}
                            </small>
                            <br>
                            <mat-slide-toggle (change)="changeDisclaimer()"
                                [checked]="emailTemplate['add_disclaimer'] == 1">
                                {{ 'Add Disclaimer' | translate }}
                            </mat-slide-toggle>
                            <br>
                            <br>
                            <app-tinymce #tinymceDisclaimer formControlName="disclaimer_text" id="disclaimer_text"></app-tinymce>
                            <br>
                            <div class="sample-email-tags" *ngIf="emailTemplate['supporting_placeholders']">
                                <strong>{{ 'Supporting placeholders' | translate }}</strong>: {{ emailTemplate['supporting_placeholders'] }}.
                            </div>
                            <br *ngIf="emailTemplate['supporting_links']">
                            <div class="sample-link-tags" *ngIf="emailTemplate['supporting_links']">
                                <strong>{{ 'Supporting links' | translate }}</strong>: {{ emailTemplate['supporting_links'] }}.
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-xs-12 text-xs-right">
                            <button type="button" class="btn btn-secondary" (click)="hideModal()">
                                {{ 'Cancel' | translate }}
                            </button>
                            <button type="submit" class="btn btn-primary">
                                <span>{{ 'Save' | translate }}</span>
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>
